import { Box, Container } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import Header from '../components/header';
import MobileNavDrawer from '@/components/mobile-nav-drawer';
import { MenuProvider } from '@/hooks/use-menu.tsx';
import { SidebarProvider } from '@/hooks/use-sidebar.tsx';

export default function LayoutPage() {
  return (
    <MenuProvider>
      <SidebarProvider>
        <Box bgColor='gray.50' minH='100vh' w='full'>
          <Header />
          <MobileNavDrawer />
          <Container maxW='container.xl' bgColor='gray.50'>
            <Outlet />
          </Container>
        </Box>
      </SidebarProvider>
    </MenuProvider>
  );
}
